if (!customElements.get('product-available')) {
  class ProductAvailable extends HTMLElement {
    constructor() {
      super();

      this.updateAvailabilityRef = this.updateAvailability.bind(this);
    }

    updateAvailability(event) {
      this.classList.toggle('in-stock', event.detail.isAvailable);
    }

    disconnectedCallback() {
      document.removeEventListener(
        'exo:update-availability',
        this.updateAvailabilityRef,
      );
    }

    connectedCallback() {
      document.addEventListener(
        'exo:update-availability',
        this.updateAvailabilityRef,
      );
    }
  }

  customElements.define('product-available', ProductAvailable);
}
